"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorAttendingOfficesApiResponseSchema = exports.doctorAttendingOfficeApiSchema = void 0;
const zod_1 = require("zod");
/**
 * One office an attending doctor practises in, as returned by
 * `GET /doctor-attendings/:id/offices`.
 */
exports.doctorAttendingOfficeApiSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.literal('doctor-attending-offices'),
    attributes: zod_1.z.object({
        doctorAttendingId: zod_1.z.string(),
        officeId: zod_1.z.string(),
        officeName: zod_1.z.string(),
    }),
});
exports.getDoctorAttendingOfficesApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.doctorAttendingOfficeApiSchema),
});
